"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chatGptModels = exports.loginPluginCode = exports.pluginCode = void 0;
exports.pluginCode = {
  AWS_SES: "AWS_SES",
  FACEBOOK_WIDGET: "FACEBOOK_WIDGET",
  GOOGLE_ANALYTICS: "GOOGLE_ANALYTICS",
  TRUSTPILOT_WIDGET: "TRUSTPILOT_WIDGET",
  TWILIO: "TWILIO",
  AWS_SNS: "AWS_SNS",
  TWITTER_WIDGET: "TWITTER_WIDGET",
  ELFSIGHT_WIDGET: "ELFSIGHT_WIDGET",
  GETSITECONTROL: "GETSITECONTROL",
  SURVEYMONKEY: "SURVEYMONKEY",
  PINTEREST_WIDGET: "PINTEREST_WIDGET",
  TYPEFORM: "TYPEFORM",
  CALENDLY: "CALENDLY",
  LANDBOT: "LANDBOT",
  STRIPE: "STRIPE",
  ATOM_CHAT: "ATOM_CHAT",
  SNIPCART: "SNIPCART",
  LOGIN: "LOGIN",
  LOGIN_WITH_BACKENDLESS: "LOGIN_WITH_BACKENDLESS",
  LOGIN_WITH_FIREBASE: "LOGIN_WITH_FIREBASE",
  LOGIN_WITH_XANO: "LOGIN_WITH_XANO",
  SUBSCRIBE: "SUBSCRIBE",
  PLAID: "PLAID",
  GOOGLE_MAP: "GOOGLE_MAP",
  MAGIC_LINK_LOGIN: "MAGIC_LINK_LOGIN",
  MULTI_TENANT_SAAS: "MULTI_TENANT_SAAS",
  STRIPE_CONNECT: "STRIPE_CONNECT",
  QUESTIONNAIRE_SURVEY_FORM: "QUESTIONNAIRE_SURVEY_FORM",
  XANO: "XANO",
  SUPABASE: "SUPABASE",
  AIRTABLE: "AIRTABLE",
  NOTION: "NOTION",
  BNG_PAYMENT: "BNG_PAYMENT",
  FLUID_PAY: "FLUID_PAY",
  FIREBASE: "FIREBASE",
  FIRESTORE: "FIRESTORE",
  APPWRITE: "APPWRITE",
  BACKGROUND_TASK: "BACKGROUND_TASK",
  CHAT_GPT: "CHAT_GPT",
  PERMISSIONS_MANAGE: "PERMISSIONS_MANAGE",
  MESSAGING: "MESSAGING",
  DATA_FORM_SEARCH_HISTORY: "DATA_FORM_SEARCH_HISTORY",
  CHATGPT_CHATBOT_MESSAGING: "CHATGPT_CHATBOT_MESSAGING",
  TWO_FACTOR_AUTHENTICATION: "TWO_FACTOR_AUTHENTICATION",
  IMAGINE_PAY: "IMAGINE_PAY",
  DOCUSIGN: "DOCUSIGN",
  AMAZON_TEXTRACT: "AMAZON_TEXTRACT",
  FILE_ACTIVITY_TRACKER: "FILE_ACTIVITY_TRACKER",
  USER_ACTIVITY_TRACKER: "USER_ACTIVITY_TRACKER",
  AWS_S3: "AWS_S3",
  LOAN_MANAGEMENT: "LOAN_MANAGEMENT",
  OAUTH_2: "OAUTH_2",
  DATA_VIEW_ACTIVITY_TRACKER: "DATA_VIEW_ACTIVITY_TRACKER",
  FACEBOOK_LOGIN: "FACEBOOK_LOGIN",
  TWITTER_LOGIN: "TWITTER_LOGIN",
  STRIPE_PAYMENT_METHODS: "STRIPE_PAYMENT_METHODS",
  EMAIL_OTP_AUTHENTICATOR: "EMAIL_OTP_AUTHENTICATOR",
  AWS_SIGNATURE: "AWS_SIGNATURE",
  SMS_OTP_AUTHENTICATOR: "SMS_OTP_AUTHENTICATOR",
  EMAIL_OTP_CONSENT_VALIDATOR: "EMAIL_OTP_CONSENT_VALIDATOR",
  SMS_OTP_CONSENT_VALIDATOR: "SMS_OTP_CONSENT_VALIDATOR",
  TEXT_ANONYMIZATION_ACTIVITY_TRACKER: "TEXT_ANONYMIZATION_ACTIVITY_TRACKER",
  AUDIT_LOG: "AUDIT_LOG",
  AUDIT_TRAIL: "AUDIT_TRAIL",
  TYPESENSE_SEARCH: "TYPESENSE_SEARCH",
  SOCKET_IO: "SOCKET_IO",
  SENDGRID: "SENDGRID",
  FIGMA: "FIGMA"
};
exports.loginPluginCode = [exports.pluginCode.LOGIN, exports.pluginCode.LOGIN_WITH_BACKENDLESS, exports.pluginCode.LOGIN_WITH_FIREBASE, exports.pluginCode.LOGIN_WITH_XANO];
exports.chatGptModels = [{
  label: "GPT 3.5",
  value: "gpt-3.5-turbo"
}, {
  label: "GPT 4.0",
  value: "gpt-4"
}];